import script from "./DeleteProjectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteProjectModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteProjectModal.vue?vue&type=style&index=0&id=51b44ea1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b44ea1"]])

export default __exports__